<template>
  <Modal :show="show" @close="close()">
    <!--<ModalSuccess  :title="successTitle" :bodyText="successBody" buttonText="Got it!"-->
    <!--@close="close()"/>-->
    <template v-if="success">
      <div class="modal-header">
        <h2 class="modal-title">Your kit is on its way!</h2>
      </div>
      <div class="modal-body">
        <p
          class="text-center"
        >Please follow the instructions in the kit to take your sample once it arrives.</p>
        <p class="text-center" v-if="hasQuestionnaries">
          Your next step is to complete study-associated questionnaires for this sample. You will find these by clicking the Questionnaires icon in the grey bar on the left of the screen or
          <router-link :to="{ name : 'Surveys' }">click here</router-link>.
          These questionnaires are available now. Please complete them as per the instructions provided by your project co-ordinator.
          <br />
          <br />Ensure that the 'Day of Sampling' questionnaire is completed on the day you take your sample.
        </p>

        <div class="row text-center mt-5">
          <div class="col-12">
            <a @click.prevent="successClose" class="btn btn-primary" href="#">Proceed</a>
            <!--<router-link :to="{ name: 'Your kits' }" class="btn btn-primary" href="#">Proceed</router-link>-->
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="successLater">
      <div class="modal-header">
        <h2
          class="modal-title"
        >Head to your "My Research" page to activate your kit when you are ready</h2>
      </div>
      <div class="row text-center mt-5">
        <div class="col-12">
          <a @click.prevent="successClose" class="btn btn-primary" href="#">Close</a>
          <!--<router-link :to="{ name: 'Your kits' }" class="btn btn-primary" href="#">Proceed</router-link>-->
        </div>
      </div>
    </template>
    <template v-if="!success && !successLater && step == 'REDEEM_CODE_WITH_ADDRESS'">
      <div class="modal-body" v-if="!success">
        <div class="modal-header">
          <h2 class="modal-title">Send the kit to me now</h2>
        </div>

        <div class="modal-body">
          <p>
            This sampling kit is associated with the
            <span v-if="project">{{ project.name }}</span> project.
          </p>
          <p>To have this kit sent to you now, please confirm your shipping details and click Proceed to confirm.</p>
          <p>Sending this kit will result in immediate dispatch to the address below.</p>
          <ModalAddress ref="address" v-model.sync="editedUser" />
        </div>

        <!--<transition name="slide-fade">-->
        <!--<div v-if="error" class="alert alert-danger" role="alert">-->
        <!--Voucher code not valid for redemption: {{ voucher }}-->
        <!--</div>-->
        <!--</transition>-->

        <!--<div class="row">-->
        <!--<div class="col-12">-->
        <!--<label for="voucher" class="h6">Enter your voucher code</label>-->
        <!--<p class="voucherSubtitle">If you have purchased or been given a kit, you will have been supplied a voucher code in an email.</p>-->
        <!--<input v-model="voucher" id="voucher" type="text" class="share-voucher"-->
        <!--placeholder="Voucher code"/>-->
        <!--</div>-->
        <!--</div>-->

        <div class="row text-center mt-3">
          <div class="col-12">
            <a
              class="btn btn-primary"
              :class="errors.items && errors.items.length ? 'disabled':''"
              href="#"
              v-on:click.prevent="activateKit"
              :disabled="errors.any() || !canSubmit"
            >Proceed</a>
          </div>
        </div>

        <!--<div class="row text-center mb-4 mt-4">-->
        <!--<div class="col-12">-->
        <!--<button class="btn plain" @click="successLater = true"><em>I don't want to send this kit now.</em></button>-->
        <!--</div>-->
        <!--</div>-->
      </div>
    </template>
    <template v-if="step == 'KIT_READY'">
      <div class="modal-body" v-if="!success">
        <div class="modal-main mb-3">
          <div class="modal-header text-center">
            <h2 class="modal-title">You have a kit ready</h2>
            <p
              class="text-center w-100"
            >You have a kit ready to be sent to you. Please click the Proceed button to action this for delivery now.</p>
          </div>
        </div>
        <div class="row text-center">
          <div class="col-12">
            <a
              class="btn btn-primary"
              href="#"
              @click.prevent="step = 'REDEEM_CODE_WITH_ADDRESS'"
            >Proceed</a>
          </div>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/models/Modal'
import ModalSuccess from '@/components/models/components/ModalSuccess'
import ModalAddress from '@/components/models/components/ModalAddress'
import ModalSendAKit from '@/components/models/ModalSendAKit'
import ModalOrder from '@/components/models/ModalOrder'
import UserMixins from '@/mixins/userProfile'

export default {
  name: 'ModalActivate',
  props: ['kitID', 'activateModal', 'setStep'],
  mixins: [UserMixins],
  extends: Modal,
  components: {
    Modal,
    ModalAddress,
    ModalSuccess,
    ModalSendAKit,
    ModalOrder
  },
  mounted: function () {
    this.editedUser = this.user
  },
  data: function () {
    return {
      isEditing: false,
      voucher: '',
      selectedKit: null,
      step: 'REDEEM_CODE_WITH_ADDRESS',
      option: null,
      loading: false,
      success: false,
      error: null,
      successLater: false,
      showSendModal: false,
      showReplacementModal: false,
      radioButtonValue: null,
      replacementKitProduct: {
        amount: Number(process.env.PRICE_NEW_KIT) || 419.0,
        label: '1 Microba insight kit',
        orderType: 'NEW'
      },
      editedUser: {
        firstName: '',
        lastName: '',
        addressLine1: '',
        addressLine2: '',
        suburb: '',
        postcode: ''
      },
      activate: true
    }
  },
  computed: {
    hasQuestionnaries () {
      return (
        this.project.exerciseSurveyEnabled ||
        this.project.foodSurveyEnabled ||
        this.project.medicalSurveyEnabled ||
        this.project.mentalSurveyEnabled ||
        this.project.samplingSurveyEnabled ||
        this.project.infantDemographicAndMilkFeedingEnabled ||
        this.project.infantDayOfSamplingEnabled ||
        this.project.infantMedicalHistoryEnabled
      )
    },
    giveToChild () {
      return this.option === 'REDEEM_CHILD'
    },
    successTitle () {
      if (!this.successLater) {
        return 'Great news, your kit is on its way!'
      } else {
        return 'Your Kit is Available'
      }
    },
    successBody () {
      if (!this.successLater) {
        return ''
      } else {
        return 'Click "Select option" again when you are ready to send this kit.'
      }
    },
    optionSpacing () {
      return 'col-md-4'
    },
    showChildOption () {
      return !this.user.underAge && !this.user.guardian
    },
    getKitId () {
      return this.kitID
    },
    user: function () {
      return this.$store.state.GET_USER_RESPONSE || false
    },
    canSubmit: function () {
      return this.isValidAddress(this.editedUser) && this.voucher !== ''
    },
    successMessage () {
      if (!this.activate) {
        return 'Your kit will be sent in the next round of kit dispatches'
      }
      return "When you're ready, you can choose to activate this kit in My Journey."
    },
    getKits: function () {
      return this.$store.state.GET_KITS_RESPONSE
    },
    project () {
      let self = this
      if (!this.getKits) return
      for (let proj = 0; proj <= self.getKits.length; proj++) {
        if (self.getKits[proj] && self.getKits[proj]['kits']) {
          for (let kit = 0; kit <= self.getKits[proj]['kits'].length; kit++) {
            if (
              self.getKits[proj]['kits'][kit] &&
              self.getKits[proj]['kits'][kit]['id'] &&
              self.getKits[proj]['kits'][kit]['id'] === self.kitID
            ) {
              return self.getKits[proj]
            }
          }
        }
      }
      return { name: '' }
    }
  },
  methods: {
    successClose () {
      this.$router.push({ name: 'Your kits' })
      this.close()
    },
    setOption (option) {
      this.option = option
      //        this.step = step
    },
    setTab (type) {
      this.step = type
    },
    setTabFromOption () {
      if (this.option === 'REDEEM_SEND') {
        this.setTab('REDEEM_CODE_WITH_ADDRESS')
      } else if (this.option === 'REDEEM_SEND_LATER') {
        this.step = ''
        this.option = null
        this.exitSuccess()
      } else if (this.option === 'REDEEM_CHILD') {
        this.setTab('REDEEM_REJECT')
      } else if (this.option === 'REDEEM_GIVE') {
        this.openGive()
      }
    },
    onShow: function () {
      this.selectedKit = null
      this.step = this.setStep || 'REDEEM_CODE_WITH_ADDRESS'
      this.option = null
      this.voucher = ''
      this.loading = false
      this.success = false
      this.successLater = false
      this.error = null
      this.showSendModal = false
      this.editedUser = Object.assign({}, this.user)
    },
    checkVoucher (type) {
      //
      //
      //          if (type === 'GIVE') {
      //            self.openGive()
      //          } else if (type === 'SEND_TO_ME') {
      //            self.exeRedeem(self.selectedKit.kitId, true)
      //          } else if (type === 'SEND_LATER') {
      //            self.exeRedeem(self.selectedKit.kitId, false)
      //          } else if (type === 'REDEEM_CONSENT') {
      //            self.setTab('REDEEM_CONSENT')
      //          }
      //
    },
    onRedeem: function () {
      // Check code is valid
      if (this.option === 'REDEEM_SEND_LATER') {
        this.checkVoucher('SEND_LATER')
      } else if (this.option === 'REDEEM_CHILD') {
        if (this.step === 'REDEEM_CONSENT') {
          this.setTab('REDEEM_ADDRESS')
        } else {
          this.checkVoucher('REDEEM_CONSENT')
        }
      }
    },
    openGive () {
      this.showSendModal = true
    },
    openBuy () {
      this.showReplacementModal = true
    },
    sendNow () {
      this.exeRedeem(this.selectedKit.kitId, true)
      this.setTab('')
    },
    sendLater () {
      this.exeRedeem(this.selectedKit.kitId, false)
      this.setTab('')
    },
    exitSuccess () {
      this.$store.dispatch('getResearchKits')
      this.$store.dispatch('getSentKits')
      this.loading = false
      this.success = true
      this.successLater = true
      this.$router.push({ path: 'kits' })
    },
    activateKit () {
      this.successLater = false
      const payload = {
        kitId: this.kitID,
        firstName: this.editedUser.firstName,
        lastName: this.editedUser.lastName,
        addressLine1: this.editedUser.addressLine1,
        addressLine2: this.editedUser.addressLine2,
        suburb: this.editedUser.suburb,
        state: this.editedUser.state,
        postcode: this.editedUser.postcode
      }

      this.loading = true
      this.$store
        .dispatch('activateKit', payload)
        .then(success => {
          this.$store.dispatch('getResearchKits')
          this.$store.dispatch('getSentKits')
          this.success = true
          this.loading = false
        })
        .catch(error => {
          console.log(error)
          // Refresh regardless
          this.$store.dispatch('getResearchKits')
          this.$store.dispatch('getSentKits')
        })
    },
    logout: function () {
      this.$store.dispatch('logout').then(() => {
        this.$router.push('/login')
      })
    },
    logoutRegister () {
      this.$store.dispatch('logout').then(() => {
        this.$router.push('/register')
      })
    }
  },
  watch: {
    showSendModal () {
      if (this.showSendModal === false) {
        this.close()
      }
    },
    showReplacementModal () {
      if (this.showReplacementModal === false) {
        this.close()
      }
    }
  }
}
</script>

<style scoped lang="scss">
.form {
  padding-top: 1rem;
  margin-top: 1rem;
}

.titleText {
  font-size: 22px;
}

img {
  margin: 0px auto;
}

.btn-option {
  border: 1px solid #eaeaea;
  border-radius: 10px;
  white-space: normal;
  text-align: center;
  padding: 13px;
  font-size: 14px;
}

a.btn-option:hover {
  border: 2px solid #f08c35;
  box-shadow: 0px 0px 4px #ccc;
}

a.btn-option.active {
  color: #01b299;
  border: 2px solid #01b299;
  box-shadow: 0px 0px 4px #ccc;
}

a.btn-option.active .dot {
  display: inline-block;
}

.dot {
  position: absolute;
  top: -10px;
  right: 27px;
  display: none;
  height: 25px;
  width: 25px;
  background-color: #01b299;
  color: #fff;
  border-radius: 50%;
  padding-left: 1px;
  padding-top: 4px;
}

.radioHint {
  margin-left: 30px;
  font-size: 14px;
}
.flex-center-vertically {
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 400px;
}

.form-checkbox {
  label {
    color: #ff8708 !important;
  }
}

label {
  color: #ff8708 !important;
}

label.h6 {
  color: #000 !important;
  margin-bottom: 5px;
}

.optImg {
  max-width: 100px;
}

.voucherSubtitle {
  font-size: 14px;
}

.modal-address {
  padding-top: 2rem;
  padding-bottom: 1.5rem;
}

.modal-header {
  img {
    margin-bottom: 2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/application/research/models/ModalActivate.vue